import { NgModule } from '@angular/core';

import { MasterSearch1Actions } from './master-search-1.actions';

@NgModule({
  providers: [
    MasterSearch1Actions
  ]
})
export class MasterSearch1ActionsModule {}
